/* Shared paid-line queue. GiftPro alone adds/removes actual gift lines. */
(() => {
  if (window.MouniCartController) return;
  const root = window.Shopify?.routes?.root || '/';
  const drawer = () => document.getElementById('halo-cart-sidebar');
  const page = () => document.querySelector('[data-mouni-cart-page]');
  const rows = () => document.querySelectorAll('#halo-cart-sidebar .previewCartItem[data-key], [data-mouni-cart-row]');
  const settings = () => document.querySelector('mouni-header-settings')?.dataset || {};
  const pending = new Map();
  let cart = null, running = false, refresh = null, latestSections = null;
  let giftEligible = null, giftCelebrationPending = false;
  const burstTimers = new WeakMap();
  let confirmedDrawer = '', confirmedPage = '';
  const api = {get busy() {return running || pending.size > 0;}};
  window.MouniCartController = api;
  api.isGift = item => {
    const properties = item.properties || {};
    if (properties._auto_added_by_rule && String(properties._auto_added) === 'true') return true;
    if (window.MouniQuickCartV37?.isGiftProLine) return window.MouniQuickCartV37.isGiftProLine(item);
    return Object.entries(item.properties || {}).some(([key, value]) => !key.toLowerCase().startsWith('_mouni') && /gift|هدية/i.test(key + ' ' + value)) || (item.line_level_discount_allocations || []).some(a => /gift|هدية/i.test(a.discount_application?.title || ''));
  };
  api.summary = state => (state?.items || []).reduce((sum, item) => {
    if (!api.isGift(item)) {sum.count += item.quantity; sum.total += item.final_line_price; sum.original += item.original_line_price;}
    return sum;
  }, {count: 0, total: 0, original: 0});
  const signature = state => JSON.stringify((state?.items || []).map(i => [i.key, i.quantity, i.final_line_price]));
  const money = cents => new Intl.NumberFormat('en-US', {minimumFractionDigits:2, maximumFractionDigits:2}).format(cents / 100) + ' ' + ((cart?.currency || 'EGP') === 'EGP' ? 'ج.م' : cart.currency);
  const parse = html => new DOMParser().parseFromString(html, 'text/html');
  const snapshot = doc => {const node = doc?.querySelector('[data-mouni-cart-page-snapshot], [data-mouni-cart-snapshot]'); try {return node ? JSON.parse(node.textContent) : null;} catch (_) {return null;}};
  const readSnapshot = () => cart = snapshot(page()) || snapshot(drawer()) || cart;
  const rowItem = key => cart?.items?.find(item => item.key === key);
  const getLimit = (row,state=cart) => {
    if(row.dataset.stockTotal==='' || row.dataset.stockTotal==null)return row.dataset.stockLimit===''||row.dataset.stockLimit==null?Infinity:Math.max(0,Number(row.dataset.stockLimit));
    const others=(state?.items||[]).filter(item=>String(item.variant_id)===String(row.dataset.variantId)&&item.key!==row.dataset.key).reduce((sum,item)=>sum+Number(item.quantity),0);
    return Math.max(0,Number(row.dataset.stockTotal)-others);
  };
  const errorMessage = message => {
    for (const host of [drawer()?.querySelector('.halo-sidebar-header'), page()]) {
      if (!host) continue;
      let el = host.querySelector('[data-mouni-cart-error]');
      if (!el && message) {el = document.createElement('p'); el.dataset.mouniCartError = ''; el.setAttribute('role','alert'); host.prepend(el);}
      if (el) el.textContent = message;
    }
  };
  const burst = row => {
    if (settings().giftSurprise === 'false' || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const host = row.closest('#halo-cart-sidebar, [data-mouni-cart-page]');
    if (!host || (host === drawer() && !document.body.classList.contains('cart-sidebar-show'))) return;
    if (host) host.dataset.giftCelebrations = String(Number(host.dataset.giftCelebrations || 0) + 1);
    clearTimeout(burstTimers.get(host));
    host.querySelector(':scope > .mouni-gift-burst')?.remove();
    const fx = document.createElement('span'); fx.className = 'mouni-gift-burst'; fx.setAttribute('aria-hidden','true');
    const bounds = host.getBoundingClientRect(), rowBounds = row.getBoundingClientRect();
    fx.style.top = Math.max(100, Math.min(bounds.height - 110, rowBounds.top - bounds.top + rowBounds.height / 2)) + 'px';
    const seal = document.createElement('b'); seal.textContent = '🎁'; fx.append(seal);
    for (let i = 0; i < 32; i++) {
      const particle = document.createElement('i'), angle = i * Math.PI * 2 / 32;
      particle.style.setProperty('--x', Math.round(Math.cos(angle) * (85 + i % 4 * 22)) + 'px');
      particle.style.setProperty('--y', Math.round(Math.sin(angle) * 85 - 25) + 'px');
      particle.style.setProperty('--r', (i * 47) + 'deg');
      particle.style.background = ['#f41487','#ffd43b','#0985d4','#48cbb5'][i % 4]; fx.append(particle);
    }
    host.append(fx); row.classList.remove('mouni-gift-surprise');
    requestAnimationFrame(() => row.classList.add('mouni-gift-surprise'));
    burstTimers.set(host, setTimeout(() => {fx.remove(); row.classList.remove('mouni-gift-surprise');}, 1800));
  };
  const paintSummary = state => {
    const sum = api.summary(state);
    window.MouniCommerce?.updateCartCount(sum.count);
    document.querySelectorAll('[data-mouni-paid-count], #halo-cart-sidebar [data-cart-count]').forEach(n => n.textContent = sum.count);
    document.querySelectorAll('[data-mouni-paid-total]').forEach(n => n.innerHTML = money(sum.total));
    document.querySelectorAll('[data-mouni-cart-total-amount]').forEach(n => n.textContent = (sum.total / 100).toLocaleString('en-US', {maximumFractionDigits:2}));
    document.querySelectorAll('[data-mouni-paid-subtotal]').forEach(n => n.innerHTML = money(sum.original));
    document.querySelectorAll('[data-saved-discount-value]').forEach(n => n.innerHTML = money(Math.max(0, sum.original - sum.total)));
    document.querySelectorAll('[data-saved-discount-display]').forEach(n => n.style.display = sum.original > sum.total ? '' : 'none');
    const total = drawer()?.querySelector('[data-mouni-v27-total-number]');
    if (total) total.textContent = (sum.total / 100).toLocaleString('en-US', {maximumFractionDigits:2});
    const eligible = sum.total >= (Number(settings().giftThreshold) || 150000);
    let actualVisible = false;
    rows().forEach(row => {const item = state.items.find(i => i.key === row.dataset.key); if (item && api.isGift(item)) {row.hidden = !eligible; row.dataset.mouniGift = 'true'; if (eligible) actualVisible = true;}});
    for (const host of [drawer()?.querySelector('.previewCartList'), page()?.querySelector('.cart-list')]) {
      if (!host) continue;
      // Keep gift rows first in both visual and reading order after every refresh.
      [...host.querySelectorAll(':scope > [data-mouni-gift="true"]')].reverse().forEach(row => {
        if (host.firstElementChild !== row) host.prepend(row);
      });
      const confirmedHere = [...host.querySelectorAll('[data-mouni-gift="true"]')].some(row => !row.hidden && !row.classList.contains('mouni-v37-gift-transition-hidden'));
      let pendingGift = host.querySelector('[data-mouni-gift-pending]');
      if (!eligible || confirmedHere) {pendingGift?.remove(); continue;}
      if (!pendingGift) {
        const template = document.querySelector('[data-mouni-gift-preview-template]');
        pendingGift = template?.content.firstElementChild?.cloneNode(true) || document.createElement('div');
        pendingGift.dataset.mouniGiftPending = ''; pendingGift.setAttribute('role','status');
        if (!template) pendingGift.textContent = settings().giftLabel || 'هدية مجانية';
        host.prepend(pendingGift);
      }
    }
    return eligible && (actualVisible || !!document.querySelector('[data-mouni-gift-pending]'));
  };
  // A drawer refresh or another increase above the threshold is not a new reward.
  const flushGiftCelebration = () => {
    if (!giftCelebrationPending) return;
    let shown = false;
    for (const host of [drawer(), page()]) {
      if (!host || (host === drawer() && !document.body.classList.contains('cart-sidebar-show'))) continue;
      const row = host.querySelector('[data-mouni-gift-pending], [data-mouni-gift="true"]:not([hidden])');
      if (row) {burst(row); shown = true;}
    }
    if (shown) giftCelebrationPending = false;
  };
  const paint = state => {
    if (!state) return;
    const eligible = api.summary(state).total >= (Number(settings().giftThreshold) || 150000);
    if (giftEligible === false && eligible) giftCelebrationPending = true;
    if (!eligible) giftCelebrationPending = false;
    giftEligible = eligible;
    paintSummary(state);
    rows().forEach(row=>{const item=state.items.find(i=>i.key===row.dataset.key);if(!item||api.isGift(item))return;const limit=getLimit(row,state);row.querySelectorAll('[data-plus-quantity-cart]').forEach(plus=>{const blocked=item.quantity>=limit;plus.hidden=false;plus.disabled=blocked;plus.tabIndex=blocked?-1:0;plus.setAttribute('aria-disabled',String(blocked));});row.querySelectorAll('[data-cart-quantity]').forEach(input=>{if(Number.isFinite(limit))input.max=String(limit);else input.removeAttribute('max');});});
    if(window.MouniCommerce){window.MouniCommerce.cart=state;document.querySelectorAll('form[data-mouni-enabled="true"]').forEach(form=>window.MouniCommerce.syncForm(form,state));}
    document.dispatchEvent(new CustomEvent('mouni:inventory-cart',{detail:{cart:state}}));
    flushGiftCelebration();
  };
  const projected = () => ({...cart, items:cart.items.map(item => {
    const change = pending.get(item.key); if (!change) return item;
    return {...item, quantity:change.quantity, final_line_price:change.quantity * item.final_price, original_line_price:change.quantity * item.original_price};
  }).filter(item => item.quantity > 0)});
  const optimistic = () => {
    if (!cart) return;
    rows().forEach(row => {
      const change = pending.get(row.dataset.key); if (!change) return;
      row.hidden = change.quantity === 0;
      row.querySelectorAll('[data-cart-quantity]').forEach(input => input.value = change.quantity);
      row.querySelectorAll('[data-plus-quantity-cart]').forEach(plus => {const blocked = change.quantity >= getLimit(row); plus.hidden = false; plus.disabled = blocked; plus.tabIndex = blocked ? -1 : 0; plus.setAttribute('aria-disabled', String(blocked));});
      row.querySelectorAll('[data-item-price-with-quantity-display]').forEach(n => n.innerHTML = money(change.quantity * change.item.final_price));
      row.classList.add('mouni-cart-pending');
    });
    paint(projected());
  };
  const render = (sections, next) => {
    const wrapper = drawer()?.querySelector('.previewCart-wrapper');
    if (wrapper && sections?.['mouni-cart-content']) {const doc = parse(sections['mouni-cart-content']); wrapper.innerHTML = (doc.querySelector('#shopify-section-mouni-cart-content') || doc.body).innerHTML;}
    const currentPage = page(), pageHTML = sections?.[currentPage?.dataset.sectionId];
    if (currentPage && pageHTML) {
      const fresh = parse(pageHTML).querySelector('[data-mouni-cart-page]');
      if (fresh) {
        const fields = [...currentPage.querySelectorAll('textarea, input[name="discount"], input[name="conditions"]')].map(el => ({name:el.name, value:el.value, checked:el.checked}));
        currentPage.innerHTML = fresh.innerHTML;
        fields.forEach(field => currentPage.querySelectorAll('textarea, input[name="discount"], input[name="conditions"]').forEach(el => {if (el.name === field.name) {el.value = field.value; if (el.type === 'checkbox') {el.checked = field.checked; el.dispatchEvent(new Event('change', {bubbles:true}));}}}));
      }
    }
    cart = next;
    if (window.MouniCommerce) {window.MouniCommerce.cart = next; window.MouniCommerce.syncAll(false);}
    window.MouniQuickCartV37?.render(next);
    paint(next);
    confirmedDrawer = wrapper?.innerHTML || ''; confirmedPage = page()?.innerHTML || '';
    document.dispatchEvent(new CustomEvent('mouni:cart-html-refreshed', {detail:{cart:next}}));
  };
  api.consumeHTML = html => {
    const next = snapshot(parse(html || '')); if (!next) return null;
    render({'mouni-cart-content':html}, next); return next;
  };
  const sectionIDs = () => ['mouni-cart-content', page()?.dataset.sectionId].filter(Boolean);
  const reconcile = () => {
    if (refresh) return refresh;
    refresh = (async () => {
      const response = await fetch(`${location.pathname}?sections=${sectionIDs().join(',')}`, {credentials:'same-origin'});
      if (!response.ok) throw new Error('تعذر تحديث السلة، حاولي مرة أخرى.');
      const sections = await response.json(); const next = snapshot(parse(sections['mouni-cart-content'] || ''));
      if (!next) throw new Error('تعذر تحميل السلة.');
      render(sections, next); return next;
    })().finally(() => refresh = null);
    return refresh;
  };
  api.refresh = reconcile;
  const drain = async () => {
    if (running) return; running = true;
    try {
      while (pending.size) {
        const [key, change] = pending.entries().next().value, sentQuantity = change.quantity;
        const candidates = cart.items.filter(i => i.variant_id === change.item.variant_id && JSON.stringify(i.properties) === JSON.stringify(change.item.properties));
        const actual = rowItem(key) || (candidates.length === 1 ? candidates[0] : null);
        if (!actual) {pending.delete(key); continue;}
        const response = await fetch(`${root}cart/change.js`, {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify({id:actual.key, quantity:sentQuantity, sections:sectionIDs(), sections_url:location.pathname})});
        const next = await response.json();
        if (!response.ok || !Array.isArray(next.items)) throw new Error(next.description || 'تعذر تحديث السلة، حاولي مرة أخرى.');
        cart = next; latestSections = next.sections;
        if (pending.get(key)?.quantity === sentQuantity) pending.delete(key);
        else {const updated = next.items.find(i => i.variant_id === actual.variant_id && !api.isGift(i)); if (updated) pending.get(key).item = updated;}
        optimistic();
      }
      running = false;
      if (latestSections?.['mouni-cart-content']) render(latestSections, cart); else await reconcile();
    } catch (error) {
      pending.clear(); running = false;
      try {await reconcile();} catch (_) {
        const wrapper = drawer()?.querySelector('.previewCart-wrapper'); if (wrapper && confirmedDrawer) wrapper.innerHTML = confirmedDrawer;
        if (page() && confirmedPage) page().innerHTML = confirmedPage;
        readSnapshot(); paint(cart);
      }
      errorMessage(error.message || 'تعذر تحديث السلة، حاولي مرة أخرى.');
    } finally {running = false;}
  };
  const change = (row, quantity) => {
    if (!row) return false;
    if (!api.busy) {readSnapshot(); confirmedDrawer = drawer()?.querySelector('.previewCart-wrapper')?.innerHTML || ''; confirmedPage = page()?.innerHTML || '';}
    const key = row.dataset.key, item = rowItem(key);
    if (!item || api.isGift(item)) return false;
    quantity = Math.max(0, Math.floor(Math.min(quantity, getLimit(row,projected()))));
    if (!Number.isFinite(quantity)) return false;
    if(quantity===(pending.get(key)?.quantity ?? item.quantity))return true;
    pending.set(key, {quantity, item}); errorMessage(''); optimistic(); void drain(); return true;
  };
  const scope = '#halo-cart-sidebar, [data-mouni-cart-page]';
  window.addEventListener('click', event => {
    const button = event.target.closest?.('[data-plus-quantity-cart], [data-minus-quantity-cart], [data-cart-remove]');
    if (!button?.closest(scope)) return;
    const row = button.closest('.previewCartItem, [data-mouni-cart-row]');
    const current = Number(row?.querySelector('[data-cart-quantity]')?.value || 1);
    const quantity = button.hasAttribute('data-cart-remove') ? 0 : current + (button.hasAttribute('data-plus-quantity-cart') ? 1 : -1);
    if (change(row, quantity)) {event.preventDefault(); event.stopImmediatePropagation();}
  }, true);
  window.addEventListener('change', event => {
    const input = event.target;
    if (!input.matches?.('[data-cart-quantity]') || !input.closest(scope)) return;
    if (change(input.closest('.previewCartItem, [data-mouni-cart-row]'), Number(input.value))) {event.preventDefault(); event.stopImmediatePropagation();}
  }, true);
  document.addEventListener('mouni:v37-cart-painted', event => {
    const next = event.detail?.cart || event.detail;
    if (!next?.items || api.busy) return;
    if (signature(next) !== signature(cart)) {cart = next; void reconcile().catch(() => paint(next));}
    else paint(next);
  });
  let observedSnapshot = null;
  const adoptSnapshot = () => {
    const node = drawer()?.querySelector('[data-mouni-cart-snapshot]');
    if (!api.busy && node && node !== observedSnapshot) {observedSnapshot = node; readSnapshot(); paint(cart);}
  };
  const init = () => {
    readSnapshot(); if (cart) paint(cart);
    const host = drawer(); if (host) new MutationObserver(adoptSnapshot).observe(host, {subtree:true, childList:true});
    let wasOpen = document.body.classList.contains('cart-sidebar-show');
    new MutationObserver(() => {
      const open = document.body.classList.contains('cart-sidebar-show');
      if (open && !wasOpen) flushGiftCelebration();
      wasOpen = open;
    }).observe(document.body, {attributes:true, attributeFilter:['class']});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
})();
